import { Component, OnInit, ViewChild, Output, HostListener } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { MatExpansionModule } from '@angular/material/expansion';
import { ReactiveFormsModule } from '@angular/forms';
import { FieldResource } from "../../core/modules/openapi";
import {MatButtonModule} from "@angular/material/button";

@Component({
  selector: "app-button",
  imports: [MatExpansionModule, ReactiveFormsModule, MatButtonModule],
  template: `
    <div class="app-button" [formGroup]="group">
      <mat-action-row>
        <button mat-raised-button color="primary" [disabled]="!field.enabled"
                (click)="markAllAsTouched()">{{ field.displayName }}
        </button>
      </mat-action-row>
    </div>
  `,
  standalone: true,
  styleUrls: ['./button.component.sass']
})
export class ButtonComponent implements OnInit {
  field: FieldResource;
  group: FormGroup;


  constructor() { }

  ngOnInit() { }

  markAllAsTouched() {
    Object.keys(this.group.controls).forEach(key => {
      this.group.controls[key].markAsTouched();
    });
  }
}
